.de{padding:0.5rem;}